// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"NumberInputTooltip_tooltipContainer__TFQp7","tooltipIcon":"NumberInputTooltip_tooltipIcon__p9g3H","tooltipPopup":"NumberInputTooltip_tooltipPopup__i-wgo"};